/* Twin Turbo "TT" speed monogram: bold italic with a planing base cut.
   Left T is graphite (ink), right T is racing red — "Графит + racing red"
   from brand/tt-graphite-red.html, same palette as the Android redesign
   (docs/17-ANDROID-REDESIGN-AUDIT.md §19.1). Geometry is baked (skew
   already applied) so it needs no transform. */

const ACCENT_ON_LIGHT = '#E63946';
const ACCENT_ON_DARK = '#FF4D5E';
const INK = '#1F2937';

/* Tight viewBox around the glyph (content spans x 15..85, y 22..82) so the
   mark hugs adjacent text without extra padding. */
const VIEW_BOX = '10 17 80 70';
const ASPECT = 70 / 80;

type LogoTone = 'brand' | 'onDark';

interface LogoMarkProps {
  /** Rendered width in px; height follows the mark's aspect ratio. */
  size?: number;
  /** `brand` = teal primary (light backgrounds), `onDark` = white primary. */
  tone?: LogoTone;
  title?: string;
}

export function LogoMark({ size = 24, tone = 'brand', title = 'Twin Turbo' }: LogoMarkProps) {
  const primary = tone === 'onDark' ? '#FFFFFF' : INK;
  const accent = tone === 'onDark' ? ACCENT_ON_DARK : ACCENT_ON_LIGHT;
  return (
    <svg
      width={size}
      height={Math.round(size * ASPECT)}
      viewBox={VIEW_BOX}
      role="img"
      aria-label={title}
    >
      <path fill={primary} d="M18.92 22 L52.92 22 L49.69 36 L15.69 36 Z" />
      <path fill={primary} d="M28.92 22 L42.92 22 L30.68 75 L15.07 82 Z" />
      <path fill={accent} d="M50.92 22 L84.92 22 L81.69 36 L47.69 36 Z" />
      <path fill={accent} d="M60.92 22 L74.92 22 L62.68 75 L47.07 82 Z" />
    </svg>
  );
}
